var React = require('react');

function SDCZoomIn18N1 (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M17.247,16.18649l-4.33492-4.33493a6.26629,6.26629,0,1,0-1.06055,1.06055l4.335,4.33489a.5.5,0,0,0,.7071,0l.35344-.35344A.5.5,0,0,0,17.247,16.18649ZM8,12.75A4.75,4.75,0,1,1,12.75,8,4.75,4.75,0,0,1,8,12.75Z","fill":"var(--iconFill, #464646)","key":0}),React.createElement("path",{"d":"M10.5,7.25H8.75V5.5a.5.5,0,0,0-.5-.5h-.5a.5.5,0,0,0-.5.5V7.25H5.5a.5.5,0,0,0-.5.5v.5a.5.5,0,0,0,.5.5H7.25V10.5a.5.5,0,0,0,.5.5h.5a.5.5,0,0,0,.5-.5V8.75H10.5a.5.5,0,0,0,.5-.5v-.5A.5.5,0,0,0,10.5,7.25Z","fill":"var(--iconFill, #464646)","key":1})]));
}

SDCZoomIn18N1.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCZoomIn18N1;

SDCZoomIn18N1.default = SDCZoomIn18N1;
